/**
 * Used to tag a string as className, to enable tailwind auto-complete.
 * Note that you might need to configure your tailwind plugin to enable
 * this - please reach out to your nearest Aresh for support with this.
 */
export function tw(strings: TemplateStringsArray) {
    return strings.join();
}

export const isPrimitiveType = (val: unknown): val is string | number | bigint | boolean => {
    return ["string", "number", "bigint", "boolean"].includes(typeof val);
};

export function hasAValidStringValue(value: string | number | null | undefined): boolean {
    if (typeof value === "string") {
        return value.trim().length > 0;
    }
    return false;
}

export function hasAValidNumberValue(value: number | null | undefined): boolean {
    if (typeof value === "number") {
        return typeof value === "number";
    }
    return false;
}
